import { Pipe, PipeTransform } from '@angular/core';
import moment, { Moment } from 'moment';
import { DateTime } from 'luxon';

@Pipe({
  name: 'formatDate',
  standalone: false,
})
export class FormatDatePipe implements PipeTransform {
  transform(date: string | Date | Moment | DateTime | undefined, format = 'MMM Do YY HH:mm'): string {
    if (date instanceof DateTime) {
      return date.toFormat(format);
    }
    return moment(date).format(format);
  }
}
